module.exports = __webpack_public_path__ + "static/media/Loren Guerriero.e8ad74e9.png";